import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        text: {
            textTransform: 'uppercase',
            fontSize: '12px !important',
            color: `${theme.palette.secondary[700]} !important`,
            fontWeight: '500 !important',
        },

        root: {
            borderBottom: `2px solid ${theme.palette.secondary.main} !important`,
            padding: `0 ${theme.spacing(1.5)} !important`,
        },
        select: {
            minHeight: `${theme.spacing(4.5)} !important`,
            '&& .MuiSelect-select': {
                paddingBottom: '0 !important',
            },
            '&:before': {
                border: 'none !important',
            },
            '&:after': {
                border: 'none !important',
            },
            '&& .MuiSvgIcon-root': {
                width: '20px !important',
            },

        },
        selectedOption: {
            backgroundColor: `${theme.palette.primary[30]} !important`,
        },
        singleOption: {
            minHeight: `${theme.spacing(4)} !important`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },

    }
})

export default useStyles
